import React from 'react';
import styles from './styles.module.scss';
import { Button, CircularProgress } from '@mui/material';

type Props = {
  className?: any;
  loading?: boolean;
  onClick?: () => void;
  children: React.ReactNode;
  icon?: React.ReactElement;
  type?: 'submit' | 'button';
  variant?: 'send' | 'cancel';
};

const LoadingButton = ({
  icon,
  type,
  loading,
  onClick,
  children,
  className,
  variant = 'send',
}: Props) => {
  return (
    <Button
      sx={{
        '&.Mui-disabled': {
          opacity: '1',
          color: '#C0C0C0',
          background: '#D9D9D9',
        },
      }}
      onClick={onClick}
      type={type}
      className={`${styles[variant]} ${className}`}
      endIcon={icon}
      disabled={loading}
    >
      {children}
      {loading && <CircularProgress sx={{ ml: 1 }} size={20} color='inherit' />}
    </Button>
  );
};

export default LoadingButton;
